// Phone-account auth helpers — hardened: the session token lives in an
// httpOnly cookie set by the server (never readable by JS, immune to XSS
// exfiltration). localStorage keeps only non-sensitive display state.
const FLAG_KEY = "callgod_signed_in_v2";
const PHONE_KEY = "callgod_auth_phone_v1";

export function isSignedIn() {
  try {
    return localStorage.getItem(FLAG_KEY) === "true";
  } catch {
    return false; // storage unavailable
  }
}

export function getAuthPhone() {
  try {
    return localStorage.getItem(PHONE_KEY) || "";
  } catch {
    return "";
  }
}

export function setAuth(phone) {
  try {
    localStorage.setItem(FLAG_KEY, "true");
    localStorage.setItem(PHONE_KEY, phone);
  } catch {
    /* storage unavailable — session still works via cookie */
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem(FLAG_KEY);
    localStorage.removeItem(PHONE_KEY);
    // Legacy v1 token cleanup (pre-cookie sessions)
    localStorage.removeItem("callgod_auth_v1");
  } catch {
    /* ignore */
  }
}

export function maskPhone(phone) {
  if (!phone || phone.length < 4) return phone || "";
  return "•••" + phone.slice(-4);
}
